import React from 'react';
import { InstagramIcon, PinterestIcon, SnapchatIcon, TiktokIcon, TwitterIcon, YoutubeIcon, FacebookIcon } from '@revfluence/fresh-icons/brands/esm';
import { ImageIcon, VideoIcon, BlogIcon, ScrewdriverWrenchIcon } from '@revfluence/fresh-icons/solid/esm';
import { ContentType } from '@frontend/app/types/globalTypes';

export enum ViewMode {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

export const POST_TYPE_NAME: {
  [key in ContentType]?: string;
} = {
  [ContentType.ADDITIONAL_IMAGES]: 'Additional Images',
  [ContentType.ADDITIONAL_VIDEOS]: 'Additional Videos',
  [ContentType.OTHER]: 'Custom work',
  [ContentType.INSTAGRAM]: 'Instagram Post',
  [ContentType.INSTAGRAM_REEL]: 'Instagram Reel',
  [ContentType.INSTAGRAM_STORY]: 'Instagram Story',
  [ContentType.INSTAGRAM_POST]: 'Instagram Post',
  [ContentType.INSTAGRAM_VIDEO]: 'Instagram Video',
  [ContentType.YOUTUBE_DEDICATED]: 'Youtube Video',
  [ContentType.YOUTUBE_MENTION]: 'Youtube Product Mention',
  [ContentType.YOUTUBE_SHORT]: 'Youtube Short',
  [ContentType.FACEBOOK_POST]: 'Facebook Post',
  [ContentType.PINTEREST]: 'Pinterest Pin',
  [ContentType.PINTEREST_PIN]: 'Pinterest Pin',
  [ContentType.BLOG_DEDICATED]: 'Blog Post',
  [ContentType.BLOG_MENTION]: 'Blog Mention',
  [ContentType.TWITTER_POST]: 'Twitter Post',
  [ContentType.TIKTOK_VIDEO]: 'TikTok Video',
};

export const DeliverablesIcon = ({ contentType }: { contentType: ContentType }) => {
  switch (contentType) {
    case ContentType.INSTAGRAM:
    case ContentType.INSTAGRAM_POST:
      return <InstagramIcon />;
    case ContentType.INSTAGRAM_REEL:
      return <InstagramIcon />;
    case ContentType.INSTAGRAM_STORY:
      return <InstagramIcon />;
    case ContentType.INSTAGRAM_VIDEO:
      return <InstagramIcon />;
    case ContentType.ADDITIONAL_IMAGES:
      return <ImageIcon />;
    case ContentType.ADDITIONAL_VIDEOS:
      return <VideoIcon />;
    case ContentType.BLOG_DEDICATED:
      return <BlogIcon />;
    case ContentType.BLOG_MENTION:
      return <BlogIcon />;
    case ContentType.FACEBOOK_POST:
      return <FacebookIcon />;
    case ContentType.OTHER:
      return <ScrewdriverWrenchIcon />;
    case ContentType.PINTEREST_PIN:
    case ContentType.PINTEREST:
      return <PinterestIcon />;
    case ContentType.SNAPCHAT_STORY:
      return <SnapchatIcon />;
    case ContentType.TIKTOK_VIDEO:
      return <TiktokIcon />;
    case ContentType.TWITTER_POST:
      return <TwitterIcon />;
    case ContentType.YOUTUBE_DEDICATED:
    case ContentType.YOUTUBE_MENTION:
    case ContentType.YOUTUBE_SHORT:
      return <YoutubeIcon />;
    default:
      return null;
  }
};

// Special ID used for the Address field group selector
export const ADDRESS_GROUP_FIELD_ID = -123456789;
